// extracted by mini-css-extract-plugin
export default {"container":"donutChart_container__Dt2yU","subcontainer":"donutChart_subcontainer__q163J","title":"donutChart_title__xt+Nc","landscape":"donutChart_landscape__+CsGB"};